export default "__VITE_ASSET__BzkhAg1f__";